<template lang="html">
  <v-container>
      <v-layout row wrap>
        <v-flex xs12 text-xs-center>
          &#169; SarithaSangeetham. Made by <a href="https://geekmonk.tech">Geekmonk Tech</a>, Naidupeta.
        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
export default {}
</script>

<style lang="css" scoped>
</style>
